export default class StoreService {
  constructor (http, store, router) {
    this.$http = http
    this.$store = store
    this.$router = router
  }

  getStores () {
    return new Promise((resolve, reject) => {
      this.$http.get('stores')
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  createStore (data) {
    return new Promise((resolve, reject) => {
      this.$http.post('stores/store', data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  updateStore (id, data) {
    return new Promise((resolve, reject) => {
      this.$http.post(`stores/update/${id}`, data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  deleteStore (id) {
    return new Promise((resolve, reject) => {
      this.$http.delete(`stores/delete/${id}`)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }
}
